import { cwslapi,webapi } from "../index";

// 获取大区列表
export const getServerListApi = (data) => { 
  return cwslapi({
    // url: "http://109.244.44.238:8000/webapi/public/getServerList",
    url: webapi+"public/getServerList",
    method: "post",
    data,
  });
};


// 获取首页轮播小图 —— 工具类
export const getIndexImgListApi = () => {
  return cwslapi({
    url: "/common/getIndexImgList",
    method: "get",
  });
};



// 获取首页商品 - 商品管理
export const indexGoodsListApi = (data) => {
  return cwslapi({
    url: "/goods/indexGoodsList",
    method: "post",
    data,
  });
};


// 领取商品福利 —— 订单管理
export const getGoodsExchangeApi = (data) => {
  return cwslapi({
    url: "/order/getGoodsExchange",
    method: "post",
    data,
  });
};










// 搜索商品列表 - 商品管理
export const searchGoodsListApi = (data) => {
  return cwslapi({
    url: "/goods/searchGoodsList",
    method: "post",
    data,
  });
};



// 获取竞价列表 ——竞价系统  限时
export const getAuctionGoodsListApi = (data) => {
  return cwslapi({
    url: "/auction/getAuctionGoodsList",
    method: "post",
    data,
  });
};


// 获取单个竞价商品 ——竞价系统  限时 单个竞价商品
export const getAuctionGoodstApi = (data) => {
  return cwslapi({
    url: "/auction/getAuctionGoods",
    method: "post",
    data,
  });
};

// 用户出价 ——竞价系统  限时 单个竞价商品 出价
export const userBidApi = (data) => {
  return cwslapi({
    url: "/auction/userBid",
    method: "post",
    data,
  });
};


// 商品列表 - 商品管理
export const goodsListApi = (data) => {
  return cwslapi({
    url: "/goods/goodsList",
    method: "post",
    data,
  });
};





// 获取商品最大购买数量 —— 订单管理
export const getGoodsByMaxCountApi = (data) => {
  return cwslapi({
    url: "/order/getGoodsByMaxCount",
    method: "post",
    data,
  });
};



// 购买白金币商品 —— 订单管理
export const checkOutApi = (data) => {
  return cwslapi({
    url: "/order/checkOut",
    method: "post",
    data,
  });
};



// 积分商城，精品商城兑换 —— 订单管理
export const dhCheckOutApi = (data) => {
  return cwslapi({
    url: "/order/dhCheckOut",
    method: "post",
    data,
  });
};




// 获取盲盒获奖记录 —— 盲盒系統
export const getPrizeLogApi = (data) => {
  return cwslapi({
    url: "/lottery/getPrizeLog",
    method: "post",
    data,
  });
};